module.exports = __webpack_public_path__ + "8e15982ae037ffe05628cf1182a087a9.png";